import { Radio as RadioMantine } from '@mantine/core'
import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'

import { api_gateway } from '../../../conexoes/api'
import {
  filtrosArrayBarra,
  revelarBarraFiltragem,
  mudarFiltros,
  limpadorFiltros,
  realizouFiltro
} from '../../../redux/actions'
import { useGlobal } from '../../../stores/useGlobal'
import {
  formatArrayToString,
  formatStringToNumberArray
} from '../../../utils/genericFormatters'
import Grid from '../../Mantine/Grid'
import Modal from '../../Mantine/Modal'
import MultiSelect from '../../Mantine/MultiSelect'
import Radio from '../../Mantine/Radio'

import * as S from './styles'

const REACT_QUERY_OPTIONS = {
  keepPreviousData: true,
  refetchOnWindowFocus: false
}

const WIDTH_COLUMNS = [5, 5]

const DEFAULT_FILTERS_VALUES = {
  bloqueioConsumo: '',
  estado: [],
  cidade: [],
  dsVendedor: []
}

const OPTIONS_STATUS = [
  {
    value: 'ativo',
    label: 'Ativo'
  },
  {
    value: 'inativo',
    label: 'Inativo'
  }
]

const BLOQUEIO_MAP = {
  ativo: '1',
  inativo: '0'
}

const BLOQUEIO_LABEL = {
  ativo: 'Ativo',
  inativo: 'Inativo'
}

const BLOQUEIO_FROM_NUM = {
  1: 'ativo',
  0: 'inativo'
}

export default function FiltroVirtueyesCliente({ opened, close }) {
  const { setIsLoadingGlobal } = useGlobal()
  const [filterOptions, setFilterOptions] = useState({
    states: [],
    sellers: []
  })
  const [citiesOptions, setCitiesOptions] = useState([])
  const [localFilters, setLocalFilters] = useState({
    ...DEFAULT_FILTERS_VALUES
  })
  const despacho = useDispatch()

  let filtros = useSelector((state) => state.filtrosState.filtros)
  let arrayFiltrosSimcard = []

  useEffect(() => {
    if (!filtros?.vazio) {
      const auxFilter = {
        ...DEFAULT_FILTERS_VALUES
      }

      if (filtros?.cd_vendedor) {
        auxFilter.dsVendedor = formatStringToNumberArray(filtros.cd_vendedor)
      }

      if (filtros?.ch_sigla) {
        const estados = formatStringToNumberArray(filtros.ch_sigla)
        auxFilter.estado = estados
      }

      if (filtros?.ds_pav_cidade) {
        auxFilter.cidade = [...filtros.ds_pav_cidade]
      }

      if (
        filtros?.fl_bloquear_ao_exceder === '1' ||
        filtros?.fl_bloquear_ao_exceder === '0'
      ) {
        auxFilter.bloqueioConsumo =
          BLOQUEIO_FROM_NUM[filtros.fl_bloquear_ao_exceder]
      }

      setLocalFilters(auxFilter)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtros])

  const getFilters = async () => {
    setIsLoadingGlobal(true)
    try {
      const estados = await fetchData('uf')

      // !  rudao vai fazer a rota de cidadea aceitar um array de cidades ou string '1,2,3'
      const [sellers, cities] = await Promise.all([
        fetchData('vendedor'),
        filtros.ch_sigla ? fetchData('cidade', filtros.ch_sigla) : null
      ])

      setFilterOptions((prev) => ({
        ...prev,
        states: toOptions(estados?.data?.dados),
        sellers: toOptions(sellers?.data?.dados)
      }))

      setCitiesOptions(toOptions(cities?.data?.dados))
    } finally {
      setIsLoadingGlobal(false)
    }
  }

  useQuery(['virtueyes/clientes/filters'], getFilters, {
    ...REACT_QUERY_OPTIONS
  })

  const toOptions = (data) => {
    return (
      data?.map((item) => ({
        value: item.codigo,
        label: item.descricao1,
        ...(item.stateID && { stateId: item.stateID })
      })) ?? []
    )
  }

  const getCities = async (e) => {
    setIsLoadingGlobal(true)
    try {
      const cities = await fetchData('cidade', e)
      const citiesData = toOptions(cities?.data?.dados)
      setCitiesOptions(citiesData)
    } catch (error) {
      console.error(error, 'error')
    } finally {
      setIsLoadingGlobal(false)
    }
  }

  const formattedFilter = () => {
    if (localFilters.filtroCliente !== '' && localFilters.filtroCliente) {
      arrayFiltrosSimcard.push(
        'Cliente: ' + localFilters.filtroCliente + '?DS_CLIENTE'
      )
    }

    if (localFilters.dsVendedor.length > 0) {
      localFilters.dsVendedor.forEach((item) => {
        const seller = filterOptions?.sellers?.find((e) => e.value === item)
        arrayFiltrosSimcard.push(
          'Atendido por: ' + seller?.label + '?cd_vendedor'
        )
      })
    }

    if (localFilters.estado?.length > 0) {
      const filteredStates = filterOptions?.states?.filter((item) =>
        localFilters.estado.includes(item.value)
      )

      const formattedStates = filteredStates.map(
        (item) => `Estado: ${item.label?.trim()}?ch_sigla`
      )

      arrayFiltrosSimcard.push(...formattedStates)
    }

    if (localFilters.cidade?.length > 0) {
      const formattedCities = localFilters.cidade.map(
        (item) => `Cidade: ${item.label?.trim()}?ds_pav_cidade`
      )

      arrayFiltrosSimcard.push(...formattedCities)
    }

    if (localFilters.bloqueioConsumo) {
      const auxBloqueio = BLOQUEIO_LABEL[localFilters.bloqueioConsumo]

      arrayFiltrosSimcard.push(
        `Bloqueio por consumo percentual: ${auxBloqueio}?fl_bloquear_ao_exceder`
      )
    }

    despacho(filtrosArrayBarra(arrayFiltrosSimcard))
  }

  const formatFiltersToApply = () => {
    const filters = {
      ...(localFilters.dsVendedor.length > 0 && {
        cd_vendedor: localFilters.dsVendedor.join(',')
      }),
      ...(localFilters.estado.length > 0 && {
        ch_sigla: formatArrayToString(localFilters.estado)
      }),
      ...(localFilters.cidade.length > 0 && {
        ds_pav_cidade: localFilters.cidade
      }),
      ...(localFilters.bloqueioConsumo && {
        fl_bloquear_ao_exceder: BLOQUEIO_MAP[localFilters.bloqueioConsumo]
      })
    }

    despacho(mudarFiltros(filters))
  }

  function handleFuncaoEstadosRedux() {
    formattedFilter()
    formatFiltersToApply()
    despacho(revelarBarraFiltragem(true))
    close()
  }

  const fetchData = (paramRota, param1 = null) => {
    const addParamTela = paramRota === 'cidade' || paramRota === 'uf'
    return api_gateway.post('/m1/consultar/select', {
      dados: {
        paramCampo1: param1,
        ...(addParamTela && { tela: 'VirtueyesClientes' })
      },
      condicao: {
        paramRota: paramRota
      }
    })
  }

  const handleLocalFiltroChange = async (fieldPath, value) => {
    if (fieldPath === 'cidade') {
      const filteredOptions = citiesOptions.filter((f) =>
        value.includes(f.value)
      )

      setLocalFilters((prev) => {
        return {
          ...prev,
          cidade: filteredOptions.map((item) => ({
            value: item.value,
            label: item.label,
            stateId: item.stateId
          }))
        }
      })

      return
    }

    const [parent, child] = fieldPath.split('.')

    setLocalFilters((prev) => {
      const newFilters = !child
        ? { ...prev, [parent]: value }
        : { ...prev, [parent]: { ...prev[parent], [child]: value } }

      return newFilters
    })
  }

  const handleCleanFilters = () => {
    setFilterOptions((prev) => ({
      ...prev,
      cities: []
    }))
    getFilters()
    despacho(mudarFiltros({ vazio: 'vazio' }))
    setLocalFilters({ ...DEFAULT_FILTERS_VALUES })
    despacho(filtrosArrayBarra([]))
    despacho(revelarBarraFiltragem(false))
    despacho(limpadorFiltros(false))
    despacho(realizouFiltro(true))
  }

  return (
    <Modal
      width="900px"
      type="filtro"
      titulo="Filtros"
      opened={opened}
      close={close}
      handleCleanFilters={handleCleanFilters}
      onConfirm={handleFuncaoEstadosRedux}
    >
      <S.Container>
        <S.Card>
          <Grid grow gap="16px" responsive sm={12} colSize={WIDTH_COLUMNS}>
            <RadioMantine.Group
              name="STATUS"
              value={localFilters?.bloqueioConsumo}
              onChange={(value) =>
                handleLocalFiltroChange('bloqueioConsumo', value)
              }
            >
              <S.ItemFiltro>
                <S.Label>
                  Bloqueio por consumo percentual
                  <S.SpanDimmed> (500%)</S.SpanDimmed>
                </S.Label>
                <S.RadioWrapper>
                  {OPTIONS_STATUS?.map((opcao) => (
                    <Radio
                      key={opcao.value}
                      value={opcao.value}
                      label={opcao.label}
                    />
                  ))}
                </S.RadioWrapper>
              </S.ItemFiltro>
            </RadioMantine.Group>
            <MultiSelect
              label="Atendido por"
              searchable
              options={filterOptions.sellers}
              value={localFilters.dsVendedor}
              onChange={(value) => handleLocalFiltroChange('dsVendedor', value)}
            />
          </Grid>
          <Grid grow gap="16px" responsive sm={12} colSize={WIDTH_COLUMNS}>
            <MultiSelect
              label="Estado"
              searchable
              options={filterOptions.states}
              value={localFilters.estado}
              onChange={(e) => {
                handleLocalFiltroChange('estado', e)
                getCities(e)
              }}
            />
            <MultiSelect
              label="Cidade"
              searchable
              disabled={!citiesOptions.length}
              options={citiesOptions}
              value={localFilters.cidade.map((item) => item.value)}
              onChange={(value) => {
                handleLocalFiltroChange('cidade', value)
              }}
            />
          </Grid>
        </S.Card>
      </S.Container>
    </Modal>
  )
}
